<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-text-field
      v-model="username"
      :counter="10"
      :rules="nickRules"
      :label="$t('forms.nick')"
      required
      light
    />

    <v-text-field
      v-model="name"
      :counter="30"
      :rules="nameRules"
      :label="$t('forms.name')"
      required
      light
    />

    <v-text-field
      v-model="email"
      :rules="emailRules"
      :label="$t('forms.email')"
      append-icon="mdi-email-outline"
      required
      light
    />

    <v-text-field
      v-model="password"
      :rules="passwordRules"
      type="password"
      :label="$t('forms.password')"
      required
      light
    />

    <v-select
      v-model="role"
      :items="items"
      :rules="[v => !!v || $t('forms.roleRequired')]"
      :label="$t('forms.group')"
      item-text="text"
      item-value="type"
      required
      light
    />

    <v-text-field
      v-if="role == 'distributor' || role == 'employee'"
      v-model="token"
      :label="$t('forms.token')"
      :rules="[v => !!v || $t('forms.agreeContinue')]"
      required
      light
    />
    <v-btn color="primary" block :disabled="!valid" @click="validate">{{ $t('forms.newAccount') }}</v-btn>
  </v-form>
</template>

<script>
//import { AddUser } from "../../graphql/AddUser.gql";
import gql from "graphql-tag";
export default {
  data: () => ({
    form: "register",
    valid: true,
    username: "",
    nickRules: [],
    name: "",
    nameRules: [],
    password: "",
    passwordRules: [],
    email: "",
    emailRules: [],
    role: null,
    items: [],
    error: "dasdasd",
  }),
  mounted() {
    this.nickRules = [
      (v) => !!v || this.$t("forms.nickRequired"),
      (v) => (v && v.length <= 10) || this.$t("forms.nickMax"),
      (v) => (v && v.length > 2) || this.$t("forms.nickMin"),
    ];
    this.nameRules = [
      (v) => !!v || this.$t("forms.nameRequired"),
      (v) => (v && v.length <= 30) || this.$t("forms.nameMax"),
      (v) => (v && v.length > 2) || this.$t("forms.nameMin"),
    ];
    this.passwordRules = [
      (v) => !!v || this.$t("forms.passwordRequired"),
      (v) => (v && v.length > 7) || this.$t("forms.passwordMin"),
    ];
    this.emailRules = [
      (v) => !!v || this.$t("forms.emailRequired"),
      (v) => /.+@.+\..+/.test(v) || this.$t("forms.emailValid"),
    ];
    this.items = [
      { type: "distributor", text: this.$t("forms.roles")[0] },
      { type: "consumer", text: this.$t("forms.roles")[1] },
      { type: "employee", text: this.$t("forms.roles")[2] },
      { type: "visitor", text: this.$t("forms.roles")[3] },
    ];
  },
  methods: {
    validate() {
      this.$refs.form.validate();
      if (this.valid) {
        this.$apollo
          .mutate({
            // Query
            mutation: gql`
              mutation(
                $username: String!
                $name: String!
                $role: String!
                $email: String!
                $password: String!
              ) {
                createUser(
                  userInput: {
                    username: $username
                    name: $name
                    role: $role
                    email: $email
                    password: $password
                  }
                ) {
                  token
                  userId
                  username
                }
              }
            `,
            variables: {
              email: this.email,
              password: this.password,
              name: this.name,
              username: this.username,
              role: this.role,
            },
          })
          .then((data) => {
            this.gotoApp(data.data.createUser.token);
          })
          .catch(() => {});
      }
    },
    gotoApp(token) {
      
      localStorage.setItem("apollo-token", "Bearer "+token);
      this.$router.push({ name: "app" }); //  params: { userId } }) // -> /user/123
    },
    /*
    async onSubmit () {
      const credentials = this.credentials
      try {
        const res = await this.$apollo.mutate({
          mutation: authenticateUserGql,
          variables: credentials
        }).then(({ data }) => data && data.authenticateUser)
        await this.$apolloHelpers.onLogin(res.token)
      } catch (e) {
        console.error(e)
      }
    },
    
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    }
    */
  },
};
</script>

<style scoped>
.EntryForm {
  position: relative;
  right: -500px;
  -webkit-animation: slide 0.5s forwards;
  -webkit-animation-delay: 2s;
  animation: slide 1s forwards;
  animation-delay: 1.3s;
}

@-webkit-keyframes slide {
  100% {
    right: 0;
  }
}

@keyframes slide {
  100% {
    right: 0;
  }
}
</style>
